import { all, call, put, takeEvery } from "redux-saga/effects";
import classeService from "../../commons/services/classe";
import { flow } from "../modules/flow";
import { actions, types } from "../modules/classe";

export default function* classeSaga() {
  yield takeEvery(types.CLASSE_SEARCH, searchClasse);
}

function* searchClasse(action) {
  yield* flow({
    type: action.type,

    fnTry: function* () {
      const [data] = yield all([
        call(() => classeService.searchClasse(action.payload || [])),
      ]);

      yield put(actions.updateClasse(data));

      const { callback } = action.payload;

      // callback
      if (callback && typeof callback === "function") {
        callback();
      }
    },

    fnCatch: function* () {
      // não exibir mensagem de erro...
    },
  });
}
